import { render, staticRenderFns } from "./Laboratorio.vue?vue&type=template&id=f993ea36"
import script from "./Laboratorio.vue?vue&type=script&lang=js"
export * from "./Laboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports